import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { GlobalRequestPrefix } from "src/app/core/constants";
import { RequestV2Service } from "src/app/core/request-v2.service";
import { OrganizationType } from "src/app/core/user-registration.model";
import { RegistrationQueryModel } from "src/app/registration-query.model";
import { mapNullable } from "src/utils";

@Injectable({ providedIn: "root" })
export class UserRegistrationService {
  public constructor(private readonly requestV2: RequestV2Service) {}

  public readonly organizationTypesChanges = this.requestV2
    .get({
      prefix: GlobalRequestPrefix,
      path: "/OrganizationTypes",
    })
    .pipe(
      mapNullable((apiModel) => OrganizationType.deserializeList(apiModel)),
      shareReplay(1),
    );

  public readonly userDetailsChanges = this.requestV2.get({
    prefix: GlobalRequestPrefix,
    path: "/user",
  });

  public register(data: RegistrationQueryModel): Observable<void | null> {
    return this.requestV2.post({
      prefix: GlobalRequestPrefix,
      path: "/OrganizationInformation",
      data,
    });
  }
}
